export const GITHUB_REPOSITORY_URL = 'https://github.com/konflux-ci/konflux-ui';
export const OFFICIAL_WEBSITE_URL = 'https://konflux-ci.dev/';
export const KEY_FEATURES_LIST_ITEMS: string[] = [
  'Application lifecycle management',
  'Pipeline Automation and CI/CD',
  'Component-based development',
  'Release Management',
  'Security scanning and compliance',
  'Integration with modern development tools',
];
export const STATIC_RESOURCES = [
  { url: GITHUB_REPOSITORY_URL, text: 'GitHub Repository' },
  { url: OFFICIAL_WEBSITE_URL, text: 'Official Website' },
];
